import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import MenuItem from '@mui/material/MenuItem';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { common } from '@mui/material/colors';

import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import PersonIcon from '@mui/icons-material/Person';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import ChatIcon from '@mui/icons-material/Chat';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import VpnKeyIcon from '@mui/icons-material/VpnKey';

import { Link, useLocation, useHistory } from "react-router-dom";

import { ThemeClient } from './contexts/Theme'
import { useCompany } from './contexts/Company';
import { ConfirmationNumber } from '@mui/icons-material';

import { supabase } from './supabaseClient'

function Navbar({ title, back = false }){
    const location = useLocation();
    const history = useHistory()
    const company = useCompany();

    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [labels, setLabels] = React.useState({});

    React.useEffect(() => {
        if (company?.id === 45) {
            setLabels({
                yourPath: 'Your Path',
                ranking: 'Ranking',
                gallery: 'Gallery',
                virtualLibrary: 'Virtual Library',
                messages: 'Messages',
                logout: 'Logout'
            });
        } else {
            setLabels({
                yourPath: 'Tu ruta',
                ranking: 'Ranking',
                gallery: 'Galeria',
                virtualLibrary: 'Biblioteca Virtual',
                messages: 'Mensajes',
                logout: 'Cerrar sesión'
            });
        }
    }, [company]);

    const menuItems = [
        { to: '/sessions', text: labels.yourPath, key: 'sessions', icon: <PersonIcon />, simple: true },
        { to: '/ranking', text: labels.ranking, key: 'ranking', icon: <LeaderboardIcon />, simple: false },
        { to: '/gallery', text: labels.gallery, key: 'gallery', icon: <PhotoLibraryIcon />, simple: true },
        { to: '/librarymenu', text: labels.virtualLibrary, key: 'library', icon: <LibraryBooksIcon />, simple: true },
        { to: '/messages', text: labels.messages, key: 'messages', icon: <ChatIcon />, simple: true },
    ];

    const goBack = () => {
        window.history.back();
    };

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const MenuItemComponent = ({ item }) => {
        const showMenuItem = company?.simple_mode ? item.simple : true;
      
        return showMenuItem ? (
          <Link to={item.to} style={{ textDecoration: 'none', color: 'white' }}>
            <MenuItem key={item.key} onClick={handleCloseNavMenu}>
              {item.icon}
              <Typography textAlign="center"> {item.text}</Typography>
            </MenuItem>
          </Link>
        ) : null;
      };

      
    const MenuItemLogout = () => {

        function logout(){
            supabase.auth.signOut().then(() => {
                history.push('/')
                setAnchorElNav(null);
            });
        }
    
        return (
            <MenuItem onClick={() => logout()} >
              <PersonIcon />
              <Typography textAlign="center">{labels.logout}</Typography>
            </MenuItem>
        );
      };
      
    return (
        <AppBar position="static">
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                        <>
                                {(location.pathname === '/' || location.pathname.startsWith('/sessions')) && (
                                <Box sx={{ flexGrow: 0.1 }}>
                                    <IconButton
                                        size="large"
                                        aria-label="account of current user"
                                        aria-controls="menu-appbar"
                                        aria-haspopup="true"
                                        onClick={handleOpenNavMenu}
                                        color="inherit"
                                    >
                                        <MenuIcon />
                                    </IconButton>

                                    <Menu
                                        id="menu-appbar"
                                        anchorEl={anchorElNav}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }}
                                        open={Boolean(anchorElNav)}
                                        onClose={handleCloseNavMenu}
                                    >
                                        {menuItems.map((item) => (
                                            <MenuItemComponent item={item} key={item.key} />
                                        ))} 
                                            <MenuItemLogout />
                                    </Menu>
                                </Box>
                            )}
                        </>

                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        {title}
                    </Typography>

                </Toolbar>
            </Container>
        </AppBar>
    );
}
export default Navbar;